import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { api, setVip } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [code, setCode] = useState("");

  useEffect(() => {
    if (cancelled || !sid) { if (!cancelled) setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid" && data?.vip_code) {
          setVip(data.vip_code); setCode(data.vip_code); setState("paid"); return;
        }
        if (["expired", "failed"].includes(data?.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000); else setState("error");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, cancelled]);

  return (
    <div data-testid="payment-result-page" className="grain min-h-screen flex flex-col justify-center px-5 md:px-16 py-16">
      <LogoMark className="w-14 h-14" />
      {state === "checking" && (
        <p data-testid="payment-checking" className="mt-10 font-mono uppercase tracking-[0.2em] flex items-center gap-3"><Loader2 className="animate-spin" /> Confirming your payment…</p>
      )}
      {state === "paid" && (
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="font-display uppercase text-6xl md:text-9xl leading-[0.85] mt-10">You're <span className="text-[#56ED4A]">VIP.</span></h1>
          <p className="mt-6 text-zinc-300 max-w-lg">Save this code. For the next year, show it at the door or at checkout for $5 off every JayPanduh show, plus 10% off Jay-B Real, Panduh and JayPanduh merch.</p>
          <div data-testid="payment-vip-code" className="mt-8 inline-block bg-[#56ED4A] text-black font-mono text-2xl md:text-4xl font-semibold px-6 py-4 tracking-widest">{code}</div>
        </motion.div>
      )}
      {state === "cancelled" && <h1 data-testid="payment-cancelled" className="font-display uppercase text-6xl md:text-8xl mt-10">No worries.<br />Pass is still here.</h1>}
      {state === "error" && <h1 data-testid="payment-error" className="font-display uppercase text-5xl md:text-7xl mt-10">We couldn't confirm that payment.</h1>}
      <Link to="/" data-testid="payment-back-home" className="mt-12 font-mono text-xs uppercase tracking-[0.2em] text-[#56ED4A] hover:underline">← Back to JayPanduh</Link>
    </div>
  );
}
